import { Component, ViewChild, TemplateRef, OnInit } from "@angular/core";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { HttpEventType } from "@angular/common/http";
import Swal from "sweetalert2";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { FormatosService } from "../../../../shared/services/formatos.service";

import { DigitalesService } from "../../../../shared/services/digitales.service";
import { DigitalesPesv, DigitalesPesvService } from "../../../../shared/services/digitales-pesv.service";
import { AdministracionService } from "../../../../shared/services/administracion.services";
import { Administracion } from "../../../../shared/model/administracion.model";
import { AuthService } from "../../../../shared/services/auth.service";
import { VersionesDocumentoService } from "../../../../shared/services/versiones-documento.service";
import { Subject, forkJoin, takeUntil } from "rxjs";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { EstadosDocumentoService } from "../../../../shared/services/estados-documento.service";
import { GoogleStoragePreviewService } from "../../../../shared/services/google-storage-preview.service";
import { gpcGoogleService } from "../../../../shared/services/gpcGoogle.service";
import { PlanAnualService } from "../../../../shared/services/plan-anual.service";

function normalize(str: any) {
  return str
    ? str
        .toString()
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/\s+/g, " ")
        .trim()
    : "";
}

interface ArchivoPesvCard {
  id: number;
  nombre: string;
  prefijo: string;
  file: File | null;
  formatos?: string[];
  formatosLabel?: string;
}
 
@Component({
  selector: 'app-plan-anual',
  templateUrl: './plan-anual.component.html',
  styleUrls: ['./plan-anual.component.scss']
})
export class PlanAnualComponent implements OnInit {
  
    formPlanAnual!: FormGroup;
    formEditarPlanAnual!: FormGroup;
    modalEditarPlanAnualRef: any;
    cargando = false;
    cargandoHistorial = false;
    cargandoPlanAnual = false;
    pdfUrl: SafeResourceUrl | null = null;
    @ViewChild('modalVisualizarPlanAnual') modalVisualizarPlanAnual!: TemplateRef<any>;
    @ViewChild('modalCrearPlanAnual')
    modalCrearPlanAnual!: TemplateRef<any>;
    modalCrearPlanAnualRef!: NgbModalRef;
    frmPlanAnualPesv!:FormGroup;
    historialPlanAnual: any[] = [];
    nombreDocumentoPlanAnualActivo: any | null = null;
    maestroPlanAnualActivo: any | null = null;
    usuarioLogin: any;
    tabActivo: number = 1;
    page1: number = 1;
    pageSize1: number = 10;
    searchTextHistorialPlanAnual = "";
    private formatoPlanAnualId = 3;
    descargandoPlanAnual = false;
    private vistaPreviaPlanAnual = false;
    private descargaPlanAnualCancel$ = new Subject<void>();
    // Helpers para descargas/versiones (compatibilidad con Implementación)
    descargaActivaSub: any = null;
    descargaCancelada: boolean = false;
    versionPreview: boolean = false;
    // Algunos métodos/propiedades que usan las utilidades de versión
    formData: any = {};
    documento_id: any = null;
    tiposDocumentales: any[] = [];
    // Datos temporales de versión (compatibilidad con lógica de versiones)
    versionData: any = {};
    planEditandoId: number | string | null = null;
    planEditando: any = null;
    planCodigoOriginal: string | null = null;
    fechaDesignacionMax = "";
    fechaVencimientoMin = "";
    
    // Propiedades para carga de documentos
    archivoSeleccionado: File | null = null;
    archivoSeleccionadoEditar: File | null = null;
    archivoDigitalPlanAnual: ArchivoPesvCard = {
      id: 3,
      nombre: "Plan Anual",
      prefijo: "PAT_documental",
      file: null,
      formatos: ["pdf", "doc", "docx"],
      formatosLabel: "pdf/doc/docx",
    };
    configuracionDigitalPlanAnual: DigitalesPesv | null = null;
    formatosPermitidosPlanAnual: string[] = ["pdf", "doc", "docx"];
    subiendoArchivo = false;
    progresoSubida = 0;
    mensajeSubida = "";
    estadoSubida: "" | "subiendo" | "exito" | "error" = "";
    administraciones: Administracion[] = [];
    empresaNit: string | null = null;
    nombreDocumentoSeleccionadoId: number | null = null;
    documentoDefaultPesv: any | null = null;
    nombreDocumentos: any[] = []
    pdfFileSelected: File | null = null; // Archivo PDF seleccionado
    estadosPlanAnual: any[] = [];
    hoy: string = '';
  cargandoEditarPlanAnual: boolean = false;
  
    get tienePlanAnualVigente(): boolean {
      return (this.historialPlanAnual || []).some((planAnual) => this.esPlanAnualVigente(planAnual));
    }
  
    constructor(
      private formatosService: FormatosService,
      private digitalesService: DigitalesService,
      private planAnualService: PlanAnualService,
      private versionesDocumentoService: VersionesDocumentoService,
      private administracionesService: AdministracionService,
      private authService: AuthService,
      private sanitizer: DomSanitizer,
      private fb: FormBuilder,
      private modalService: NgbModal,
      private estadoDocumentosService:EstadosDocumentoService,
      private gpcGoogle: gpcGoogleService,
      private googleStoragePreview: GoogleStoragePreviewService,
    ) {}
  
    ngOnInit() {
      this.formPlanAnual = this.fb.group({
        codigo: ['', Validators.required],
        version: ['1.0', Validators.required],
        fecha_designacion: ['', Validators.required],
        fecha_vencimiento: ['', Validators.required],
        estado: [1, Validators.required],
        motivo_creacion: ['', Validators.required],
        soporte: [null, Validators.required]
      });
  
      this.formEditarPlanAnual = this.fb.group({
        codigo: ["", Validators.required],
        fecha_designacion: ["", Validators.required],
        fecha_vencimiento: ["", Validators.required],
        estado: [1, Validators.required],
      });
  
       this.frmPlanAnualPesv = this.fb.group({
        codigo: ['', Validators.required],
        version: ['1.0', Validators.required],
        fecha_designacion: ['', Validators.required],
        fecha_vencimiento: ['', Validators.required],
        estado: [1, Validators.required],
        motivo_creacion: ['', Validators.required],
        soporte: [null, Validators.required]
      });
  
  
      this.usuarioLogin = this.authService.getCurrentUserValue();
    //  console.log('🔍 Usuario Login completo:', this.usuarioLogin.usuario);
    //  this.inicializarFechasPlanAnual();
      this.cargarNitEmpresa();
     // this.cargarConfiguracionDocumentoPlanAnual();
     this.cargarHistorialPlanAnual();
    //  this.cargarDocumentoDefaultPesv();
  
    this.getEstadoDocumento();
  
    this.frmPlanAnualPesv.get('fecha_designacion')?.valueChanges.subscribe(fecha => {
  
      if (fecha) {
  
        const fechaVencimiento = new Date(fecha);
  
        fechaVencimiento.setFullYear(
          fechaVencimiento.getFullYear() + 3
        );
  
        this.frmPlanAnualPesv.patchValue({
          fecha_vencimiento: fechaVencimiento.toISOString().split('T')[0]
        });
  
      }
  
    });
    const today = new Date();
    this.hoy = today.toISOString().split('T')[0]; // YYYY-MM-DD
    }
  
    
   
  
    // ✅ Cargar NIT de la empresa para usar en descargas y subidas a Digitales PESV
    private cargarNitEmpresa(): void {
      this.administracionesService.obtenerTodas().subscribe({
        next: (res: any) => {
          const lista = Array.isArray(res) ? res : Array.isArray(res?.administraciones) ? res.administraciones : [];
          if (lista.length > 0) {
            this.empresaNit = lista[0].nit?.toString() || null;
           // console.log('🏢 NIT de la empresa cargado:', this.empresaNit);
          }
        },
        error: (err: any) => {
          console.error('❌ Error al cargar NIT de la empresa:', err);
        },
      });
    }
  
    private inicializarFechasPlanAnual(): void {
      const hoy = new Date();
      this.fechaDesignacionMax = this.formatearFechaParaInput(hoy);
      this.fechaVencimientoMin = "";
    }
  
    private formatearFechaParaInput(fecha: Date): string {
      const año = fecha.getFullYear();
      const mes = String(fecha.getMonth() + 1).padStart(2, "0");
      const día = String(fecha.getDate()).padStart(2, "0");
      return `${año}-${mes}-${día}`;
    }
  
    private normalizarFechaParaInput(fecha: any): string {
      if (!fecha) {
        return "";
      }
  
      const valor = String(fecha);
      if (/^\d{4}-\d{2}-\d{2}$/.test(valor)) {
        return valor;
      }
  
      const d = new Date(fecha);
      if (Number.isNaN(d.getTime())) {
        return "";
      }
  
      return this.formatearFechaParaInput(d);
    }
  
    private sumarUnAño(fecha: string): string {
      if (!fecha) {
        return "";
      }
  
      const base = new Date(`${fecha}T00:00:00`);
      if (Number.isNaN(base.getTime())) {
        return "";
      }
  
      base.setFullYear(base.getFullYear() + 1);
      return this.formatearFechaParaInput(base);
    }
  
    onFechaDesignacionChange(): void {
      const fechaDesignacion = String(this.formPlanAnual.get("fecha_designacion")?.value || "").trim();
      if (!fechaDesignacion) {
        this.fechaVencimientoMin = "";
        this.formPlanAnual.get("fecha_vencimiento")?.reset();
        return;
      }
  
      const fechaVencimiento = this.sumarUnAño(fechaDesignacion);
      this.fechaVencimientoMin = fechaVencimiento;
      if (!this.formPlanAnual.get("fecha_vencimiento")?.value) {
        this.formPlanAnual.get("fecha_vencimiento")?.setValue(fechaVencimiento);
      }
    }
  
    private obtenerCarpetaDigitalPlanAnual(): string {
      const prefijo = this.configuracionDigitalPlanAnual?.siglas || this.archivoDigitalPlanAnual.prefijo || 'PAT';
      // ✅ Incluir NIT administrativo en la ruta de descarga
      const nit = this.empresaNit || 'nit';
      return `${nit}/pesv/${prefijo}`;
    }
  
    private obtenerCarpetaCargadosPlanAnual(): string {
      const prefijo = this.configuracionDigitalPlanAnual?.siglas || this.archivoDigitalPlanAnual.prefijo || 'PAT';
      return `${prefijo}`;
    }
  
    private construirNombreDescargaPlanAnual(nombreOriginal?: string): string {
      return `DOCUMENTO PLAN ANUAL SEGURIDAD VIAL.pdf`;
    }
  
    get acceptDocumentoPlanAnual(): string {
      if (!this.formatosPermitidosPlanAnual.length) {
        return ".pdf,.doc,.docx";
      }
      return this.formatosPermitidosPlanAnual.map((f) => `.${f}`).join(",");
    }
  
    get formatosPermitidosPlanAnualTexto(): string {
      return this.formatosPermitidosPlanAnual.map((f) => `.${f}`).join(", ");
    }
  
  
  
    descargarPlanAnual() {
      const formatoId = 3;
      const datos = {};
      
      this.cargando = true;
      this.formatosService.generarDocumento(formatoId, datos).subscribe({
        next: (blob: Blob) => {
          this.cargando = false;
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = `Plan_Anual_Seguridad_Vial_${new Date().getTime()}.pdf`;
          link.click();
          window.URL.revokeObjectURL(url);
          Swal.fire('Éxito', 'Plan anual descargado correctamente', 'success');
        },
        error: (err) => {
          this.cargando = false;
          Swal.fire('Error', this.obtenerMensajeError(err, 'No se pudo descargar el plan anual'), 'error');
          console.error('Error al descargar PDF:', err);
        }
      });
    }
  
    formatDateTodo(fecha: any): string {
      if (!fecha) return "N/A";
      const d = new Date(fecha);
      return `${String(d.getUTCDate()).padStart(2, "0")}/${String(
        d.getUTCMonth() + 1
      ).padStart(2, "0")}/${d.getUTCFullYear()}`;
    }
  
    onTabChange(event: any): void {
      this.tabActivo = event.nextId;
    }
  
    descargarPlanAnualDirecta(event?: Event): void {
      event?.preventDefault();
      event?.stopPropagation();
      const planAnual = this.historialPlanAnualVista?.[0];
      if (!planAnual) {
        Swal.fire("Info", "No hay plan anual registrado para descargar.", "info");
        return;
      }
    //  this.descargarDesdeHistorialPlanAnual(planAnual);
    }
  
    get historialPlanAnualVista(): any[] {
      const base = this.historialPlanAnual || [];
      const search = normalize(this.searchTextHistorialPlanAnual);
  
      if (!search) {
        return base;
      }
  
      return base.filter((item: any) => {
        const codigo = normalize(item?.codigo || "");
        const nombre = normalize(item?.nombre || "");
        const fechaDesignacion = normalize(this.formatDateTodo(item?.fecha_designacion));
        const fechaVencimiento = normalize(this.formatDateTodo(item?.fecha_vencimiento));
        const estado = this.esPlanAnualActivo(item) ? "activa" : "inactiva";
        return (
          codigo.includes(search) ||
          nombre.includes(search) ||
          fechaDesignacion.includes(search) ||
          fechaVencimiento.includes(search) ||
          estado.includes(search)
        );
      });
    }
  
    aplicarFiltroHistorialPlanAnual(): void {
      this.page1 = 1;
    }
  
    exportarHistorialPlanAnualExcel(): void {
      const datos = this.historialPlanAnualVista || [];
      if (!datos.length) {
        this.mostrarSwalAccion("info", "Sin datos", "No hay planes anuales para exportar");
        return;
      }
  
      const filas = datos.map((item: any) => ({
        CODIGO: item?.codigo || "",
        DESIGNACION: this.formatDateTodo(item?.fecha_designacion),
        VENCIMIENTO: this.formatDateTodo(item?.fecha_vencimiento),
        ESTADO: this.esPlanAnualActivo(item) ? "ACTIVO" : "INACTIVO",
      }));
  
      const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(filas);
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Planes Anuales");
      XLSX.writeFile(wb, `historial_planes_anuales_${Date.now()}.xlsx`);
      this.mostrarSwalAccion("success", "Exito", "Exportacion a Excel completada");
    }
  
    exportarHistorialPlanAnualPdf(): void {
      const datos = this.historialPlanAnualVista || [];
      if (!datos.length) {
        this.mostrarSwalAccion("info", "Sin datos", "No hay planes anuales para exportar");
        return;
      }
  
      const doc = new jsPDF("p", "pt");
      doc.setFontSize(12);
      doc.text("Historial de Planes Anuales de Seguridad Vial", 40, 35);
  
      autoTable(doc, {
        head: [["CODIGO", "DESIGNACION", "VENCIMIENTO", "ESTADO"]],
        body: datos.map((item: any) => [
          item?.codigo || "",
          this.formatDateTodo(item?.fecha_designacion),
          this.formatDateTodo(item?.fecha_vencimiento),
          this.esPlanAnualActivo(item) ? "ACTIVO" : "INACTIVO",
        ]),
        startY: 50,
        styles: { fontSize: 9 },
        headStyles: { fillColor: [13, 110, 253] },
      });
  
      doc.save(`historial_planes_anuales_${Date.now()}.pdf`);
      this.mostrarSwalAccion("success", "Exito", "Exportacion a PDF completada");
    }
 
  
    private extraerListaDocumentos(response: any): any[] {
      if (Array.isArray(response)) {
        return response;
      }
      if (Array.isArray(response?.archivos)) {
        return response.archivos;
      }
      if (Array.isArray(response?.documentos)) {
        return response.documentos;
      }
      if (Array.isArray(response?.data)) {
        return response.data;
      }
      return [];
    }
  
    private normalizarCodigoPlanAnual(codigo: string): string {
      return String(codigo || "")
        .trim()
        .replace(/[^a-zA-Z0-9_-]/g, "_")
        .replace(/_+/g, "_")
        .replace(/^_|_$/g, "");
    }
  
    private obtenerCarpetaPlanAnual(codigo: string): string {
      const codigoNormalizado = this.normalizarCodigoPlanAnual(codigo);
      return codigoNormalizado ? `pesv/plan_anual/${codigoNormalizado}` : `pesv/plan_anual`;
    }
  
    private construirNombreArchivoDocumentoPlanAnualPorCodigo(codigo: string, file: File): string {
      const extension = file.name.split(".").pop()?.toLowerCase() || "bin";
      return `PLAN_ANUAL_${this.normalizarCodigoPlanAnual(codigo)}.${extension}`;
    }
  

  
    cargarHistorialPlanAnual(): void {
      //BANDERA para indicar que se está cargando el historial de planes anuales
      this.cargandoHistorial = true;

      //CARGA del historial de planes anuales
      this.cargarHistorialPlanAnualLegacy();
    }
  
    // Carga del historial de planes anuales desde el servicio legacy
    private cargarHistorialPlanAnualLegacy(): void {

      // Llamada al servicio para obtener todos los planes anuales
      this.planAnualService.getAll().subscribe({
        next: (plananuales: any[]) => {
          const lista = Array.isArray(plananuales) ? plananuales : [];
          
          console.debug("Lista de planes anuales obtenida:", lista);

          if (!lista.length) {
            this.historialPlanAnual = [];
            this.cargandoHistorial = false;
            return;
          }
          this.historialPlanAnual = lista;
          this.cargandoHistorial = false;
  

        },
        error: (err) => {
          console.error("Error obteniendo planes anuales:", err);
          this.historialPlanAnual = [];
          this.cargandoHistorial = false;
        },
      });
    }
  
  
    esPlanAnualActivo(planAnual: any): boolean {
     // console.debug("esPlanAnualActivo", { planAnual });
     return Number(planAnual?.estado) === 3;
    }
  
    private obtenerEstadoPlanAnual(planAnual: any): string {
      const estadoNombre = [
        planAnual?.estadoDocumento?.nombre,
        planAnual?.estado_documento?.nombre,
        planAnual?.estadoNombre,
        planAnual?.estado_nombre,
        planAnual?.estado,
      ]
        .filter((valor) => valor !== null && valor !== undefined && valor !== "")
        .map((valor) => String(valor).trim().toLowerCase());
  
      if (estadoNombre.some((valor) => valor.includes("borrador"))) {
        return "BORRADOR";
      }
  
      if (estadoNombre.some((valor) => valor.includes("vigente"))) {
        return "VIGENTE";
      }
  
      if (estadoNombre.some((valor) => valor.includes("obsolet"))) {
        return "OBSOLETA";
      }
  
      if (estadoNombre.some((valor) => valor.includes("elimin"))) {
        return "ELIMINADO";
      }
  
      if (estadoNombre.some((valor) => valor.includes("rechaz"))) {
        return "RECHAZADA";
      }
  
      const estadoId = Number(
        planAnual?.estadoDocumento?.id ??
        planAnual?.estado_documento?.id ??
        planAnual?.estadoId ??
        planAnual?.estado_id ??
        planAnual?.estado
      );
  
      if ([1, 2].includes(estadoId)) {
        return "BORRADOR";
      }
  
      if ([3].includes(estadoId)) {
        return "VIGENTE";
      }
  
      if ([4, 5].includes(estadoId)) {
        return "OBSOLETA";
      }
  
      return "";
    }
  
    puedeEditarPlanAnual(planAnual: any): boolean {
      return this.obtenerEstadoPlanAnual(planAnual) === "BORRADOR";
    }
  
    private obtenerMensajeNoEditable(planAnual: any): string {
      switch (this.obtenerEstadoPlanAnual(planAnual)) {
        case "VIGENTE":
          return "El plan anual está vigente. Para modificarlo debe crear una nueva versión.";
        case "OBSOLETA":
          return "El plan anual está obsoleta. Solo se permite consulta.";
        case "ELIMINADO":
          return "El plan anual está eliminado. Se conserva solo como histórico.";
        case "RECHAZADA":
          return "El plan anual está rechazado y no puede editarse.";
        default:
          return "Solo los planes anuales en estado BORRADOR pueden editarse.";
      }
    }
  
    esPlanAnualVigente(planAnual: any): boolean {
      if (!this.esPlanAnualActivo(planAnual)) {
        return false;
      }
  
      const hoy = new Date();
      hoy.setHours(0, 0, 0, 0);
  
      const fechaDesignacion = planAnual?.fecha_designacion ? new Date(planAnual.fecha_designacion) : null;
      const fechaVencimiento = planAnual?.fecha_vencimiento ? new Date(planAnual.fecha_vencimiento) : null;
  
      if (fechaDesignacion) {
        const inicio = new Date(fechaDesignacion);
        inicio.setHours(0, 0, 0, 0);
        if (inicio > hoy) {
          return false;
        }
      }
  
      if (fechaVencimiento) {
        const fin = new Date(fechaVencimiento);
        fin.setHours(0, 0, 0, 0);
        if (fin < hoy) {
          return false;
        }
      }
  
      return true;
    }
  
    editarPlanAnualDesdeHistorial(planAnual: any): void {
      if (!planAnual || planAnual.id == null) {
        this.mostrarSwalAccion('error', 'Error', 'No se encontro el identificador del plan anual a editar');
        return;
      }
  
      if (!this.puedeEditarPlanAnual(planAnual)) {
        Swal.fire({
          icon: 'warning',
          title: 'No se puede editar',
          text: this.obtenerMensajeNoEditable(planAnual)
        });
        return;
      }
  
      this.planEditando = planAnual;
      this.planEditandoId = planAnual.id;
      this.planCodigoOriginal = this.normalizarCodigoPlanAnual(planAnual.codigo || "");
      this.archivoSeleccionadoEditar = null;
  
      const fechaDesignacion = this.normalizarFechaParaInput(planAnual.fecha_designacion);
      const fechaVencimiento = this.normalizarFechaParaInput(planAnual.fecha_vencimiento);
  
      this.formEditarPlanAnual.patchValue({
        codigo: planAnual.codigo || "",
        fecha_designacion: fechaDesignacion,
        fecha_vencimiento: fechaVencimiento,
        estado: planAnual.estado ?? planAnual.estadoDocumento?.id ?? 1,
      });
    }
  
    abrirModalEditarPlanAnual(template: any): void {
      this.modalEditarPlanAnualRef = this.modalService.open(template, { centered: true, size: 'lg' });
      this.modalEditarPlanAnualRef.result.finally(() => {
        this.archivoSeleccionadoEditar = null;
        this.formEditarPlanAnual.reset();
        this.planEditandoId = null;
        this.planEditando = null;
        this.planCodigoOriginal = null;
      });
    }
  
    private eliminarArchivosPreviosplanAnual(nombreCarpeta: string): Promise<void> {
      return new Promise((resolve) => {
        this.digitalesService.listarDocumentos(nombreCarpeta).subscribe({
          next: (respuesta: any) => {
            const documentos = this.extraerListaDocumentos(respuesta);
            const rutasAEliminar = documentos
              .map((doc) => {
                const rutaDirecta = doc?.rutaCompleta || doc?.ruta_completa || doc?.path || doc?.ruta;
                if (typeof rutaDirecta === 'string' && rutaDirecta.trim() !== '') {
                  return rutaDirecta;
                }
                const nombreArchivo = doc?.name || doc?.nombre || doc?.archivo || doc?.fileName || doc?.filename;
                if (typeof nombreArchivo === 'string' && nombreArchivo.trim() !== '') {
                  return `${nombreCarpeta}/${nombreArchivo}`;
                }
                return '';
              })
              .filter((ruta) => !!ruta && !ruta.endsWith('/'));
  
            if (rutasAEliminar.length === 0) {
              resolve();
              return;
            }
  
            let pendientes = rutasAEliminar.length;
            const finalizarSiCorresponde = () => {
              pendientes -= 1;
              if (pendientes <= 0) {
                resolve();
              }
            };
  
            rutasAEliminar.forEach((ruta) => {
              this.digitalesService.eliminarArchivo(ruta).subscribe({
                next: () => finalizarSiCorresponde(),
                error: (error) => {
                  console.warn('Advertencia al eliminar archivo previo de plan anual:', error);
                  finalizarSiCorresponde();
                },
              });
            });
          },
          error: (error) => {
            console.warn('Advertencia listando archivos previos de plan anual:', error);
            resolve();
          },
        });
      });
    }
  
guardarCambiosPlanAnual(modal: any): void {
  if (!this.formEditarPlanAnual.valid) {
    this.formEditarPlanAnual.markAllAsTouched();
    this.mostrarSwalAccion('warning', 'Validación', 'Completa todos los campos requeridos');
    return;
  }

  if (!this.planEditandoId) {
    this.mostrarSwalAccion('error', 'Error', 'No se encontro el identificador del plan anual');
    return;
  }

  const codigo = this.normalizarCodigoPlanAnual(this.formEditarPlanAnual.get('codigo')?.value);
  const fechaDesignacion = String(this.formEditarPlanAnual.get('fecha_designacion')?.value || '').trim();
  const fechaVencimiento = String(this.formEditarPlanAnual.get('fecha_vencimiento')?.value || '').trim();
  const codigoOriginal = this.planCodigoOriginal || "";
  const editarSinCambioDeVersion = !!codigoOriginal && codigo === codigoOriginal;

  if (!codigo || !fechaDesignacion || !fechaVencimiento) {
    this.mostrarSwalAccion('error', 'Error', 'Versión, fecha de designación y fecha de vencimiento son obligatorios');
    return;
  }

  const hoy = this.formatearFechaParaInput(new Date());
  if (fechaDesignacion > hoy) {
    this.mostrarSwalAccion('warning', 'Fecha inválida', 'La fecha de designación no puede ser futura en edición');
    return;
  }

  // Verificar si el código ya existe en otro plan anual
  this.planAnualService.getAll().subscribe({
    next: (planes: any[]) => {
      const planExistente = (Array.isArray(planes) ? planes : []).find(
        (plan: any) => this.normalizarCodigoPlanAnual(plan?.codigo || "") === codigo,
      );

      const codigoDuplicado = !!planExistente && String(planExistente?.id) !== String(this.planEditandoId);

      if (codigoDuplicado) {
        this.mostrarSwalAccion('warning', 'Versión duplicada', `La versión ${codigo} ya existe. Cambia la versión para poder guardar.`);
        return;
      }

      this.cargandoEditarPlanAnual = true;

      const payload = editarSinCambioDeVersion
        ? {
            fecha_designacion: fechaDesignacion,
            fecha_vencimiento: fechaVencimiento,
            estado: this.formEditarPlanAnual.get('estado')?.value,
          }
        : {
            codigo,
            fecha_designacion: fechaDesignacion,
            fecha_vencimiento: fechaVencimiento,
            estado: this.formEditarPlanAnual.get('estado')?.value,
          };

      const archivoEditar = this.archivoSeleccionadoEditar;
      const requiereSubidaArchivo = !!archivoEditar;

      const idParaActualizar = this.planEditandoId as string | number;
      this.planAnualService.update(idParaActualizar, payload).subscribe({
        next: (response) => {
          if (!requiereSubidaArchivo) {
            this.cargandoEditarPlanAnual = false;
            this.mostrarSwalAccion('success', 'Exito', 'Plan anual actualizado correctamente');
            this.planEditandoId = null;
            this.planEditando = null;
            this.planCodigoOriginal = null;
            this.archivoSeleccionadoEditar = null;
            this.formEditarPlanAnual.reset();
            this.cargarHistorialPlanAnual();
            modal.dismiss();
            return;
          }

          const nombreCarpeta = this.obtenerCarpetaPlanAnual(codigo);
          const nombreArchivo = archivoEditar
            ? this.construirNombreArchivoDocumentoPlanAnualPorCodigo(codigo, archivoEditar)
            : "";
          const prefijo = this.archivoDigitalPlanAnual.prefijo || "PAT_documental";
          const idNumerico = Number(this.archivoDigitalPlanAnual.id || 3);

          // Eliminar archivos previos antes de subir el nuevo
          this.eliminarArchivosPreviosplanAnual(nombreCarpeta)
            .then(() => {
              this.digitalesService.subirArchivo(archivoEditar as File, idNumerico, nombreCarpeta, nombreArchivo, prefijo).subscribe({
                next: (event: any) => {
                  if (event.type === HttpEventType.UploadProgress && event.total) {
                    this.progresoSubida = Math.round((100 * event.loaded) / event.total);
                  } else if (event.type === HttpEventType.Response) {
                    this.cargandoEditarPlanAnual = false;
                    this.mostrarSwalAccion('success', 'Exito', 'Plan anual y documento actualizados correctamente');
                    this.planEditandoId = null;
                    this.planEditando = null;
                    this.planCodigoOriginal = null;
                    this.archivoSeleccionadoEditar = null;
                    this.formEditarPlanAnual.reset();
                    this.cargarHistorialPlanAnual();
                    modal.dismiss();
                  }
                },
                error: () => {
                  this.cargandoEditarPlanAnual = false;
                  this.mostrarSwalAccion('error', 'Error', 'Se actualizo el registro, pero no se pudo reemplazar el documento.');
                  this.cargarHistorialPlanAnual();
                },
              });
            })
            .catch((err) => {
              console.error('Error eliminando archivos previos, continuando:', err);
              // Continuar con la subida aunque falle la eliminación
              this.digitalesService.subirArchivo(archivoEditar as File, idNumerico, nombreCarpeta, nombreArchivo, prefijo).subscribe({
                next: (event: any) => {
                  if (event.type === HttpEventType.Response) {
                    this.cargandoEditarPlanAnual = false;
                    this.mostrarSwalAccion('success', 'Exito', 'Plan anual y documento actualizados correctamente');
                    this.planEditandoId = null;
                    this.planEditando = null;
                    this.planCodigoOriginal = null;
                    this.archivoSeleccionadoEditar = null;
                    this.formEditarPlanAnual.reset();
                    this.cargarHistorialPlanAnual();
                    modal.dismiss();
                  }
                },
                error: () => {
                  this.cargandoEditarPlanAnual = false;
                  this.mostrarSwalAccion('error', 'Error', 'No se pudo reemplazar el documento.');
                },
              });
            });
        },
        error: (err) => {
          this.cargandoEditarPlanAnual = false;
          this.mostrarSwalAccion('error', 'Error', this.obtenerMensajeError(err, 'No se pudo actualizar el plan anual'));
        },
      });
    },
    error: (err) => {
      this.mostrarSwalAccion('error', 'Error', 'No se pudo verificar el plan anual');
    },
  });
}
  
cambiarEstadoPlanAnual(planAnual: any, activar: boolean): void {
  const id = planAnual?.id;

  if (!id) {
    this.mostrarSwalAccion('error', 'Error', 'No se encontro el identificador del plan anual');
    return;
  }

  const yaEnEstadoObjetivo = activar ? this.esPlanAnualActivo(planAnual) : !this.esPlanAnualActivo(planAnual);
  if (yaEnEstadoObjetivo) {
    this.mostrarSwalAccion('info', 'Sin cambios', activar ? 'El plan anual ya esta activo' : 'El plan anual ya esta inactivo');
    return;
  }

  Swal.fire({
    title: 'Confirmar accion',
    text: activar ? '¿Deseas activar este plan anual?' : '¿Deseas inactivar este plan anual?',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Si',
    cancelButtonText: 'No',
    confirmButtonColor: '#0d6efd',
  }).then((result) => {
    if (!result.isConfirmed) {
      return;
    }

    const request$ = activar
      ? this.planAnualService.activar(id)
      : this.planAnualService.inactivar(id);

    request$.subscribe({
      next: () => {
        this.mostrarSwalAccion('success', 'Exito', activar ? 'Plan anual activado correctamente' : 'Plan anual inactivado correctamente');
        this.cargarHistorialPlanAnual();
      },
      error: (err) => {
        this.mostrarSwalAccion('error', 'Error', this.obtenerMensajeError(err, activar ? 'No se pudo activar el plan anual' : 'No se pudo inactivar el plan anual'));
      },
    });
  });
}
  
    visualizarPlanAnual(id: number | string): void {
      const nombreDocumento =
        this.nombreDocumentoPlanAnualActivo?.nombre_documento ||
        this.nombreDocumentoPlanAnualActivo?.nombre ||
        "Plan Anual de Seguridad Vial";
  
      this.cargando = true;
  
      this.versionesDocumentoService
        .descargarDocumentoVigenteporNombre(nombreDocumento, "pdf")
        .subscribe({
          next: (response: any) => {
            this.cargando = false;
  
            const blob = response?.body || response;
            if (!blob || blob.size === 0) {
              Swal.fire(
                "Información",
                "No se encontró un documento vigente para plan anual.",
                "info",
              );
              return;
            }
  
            const url = URL.createObjectURL(blob);
            this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
            this.tabActivo = 1;
            Swal.fire(
              "Éxito",
              "Documento cargado. Cambiando a visualización...",
              "success",
            );
          },
          error: (err) => {
            this.cargando = false;
            Swal.fire(
              "Error",
              this.obtenerMensajeError(err, "No se pudo cargar el documento"),
              "error",
            );
            console.error("Error:", err);
          },
        });
    }
  
    private obtenerMensajeError(err: any, porDefecto: string): string {
      const mensaje = err?.error?.message || err?.error?.error || err?.message || porDefecto;
  
      if (typeof mensaje !== 'string') {
        return porDefecto;
      }
  
      if (mensaje.toLowerCase().startsWith('http failure response for')) {
        return porDefecto;
      }
  
      return mensaje;
    }
  
    private mostrarSwalAccion(
      icon: "success" | "error" | "warning" | "info" | "question",
      titulo: string,
      texto?: string,
    ): void {
      Swal.fire({
        icon,
        title: titulo,
        text: texto,
        confirmButtonColor: "#0d6efd",
      });
    }
  
  
  
    // ===========================
    // Métodos para cargar datos
    // ===========================
    cargarDataAdmin(): void {
      this.administracionesService.obtenerTodas().subscribe({
        next: (res: any) => {
          const lista = Array.isArray(res)
            ? res
            : Array.isArray(res?.administraciones)
              ? res.administraciones
              : [];
  
          this.administraciones = lista;
          if (this.administraciones.length > 0) {
            this.empresaNit = this.administraciones[0].nit?.toString() || null;
            console.log('🏢 NIT de la empresa:', this.empresaNit);
          }
        },
        error: (err: any) => {
          console.error('❌ Error al cargar administraciones:', err);
        }
      });
    }
  
    // ===========================
    // Métodos para manejo de archivos
    // ===========================
    onFileChange(event: any): void {
      const file = event.target.files[0];
      if (file) {
        const extension = file.name.split('.').pop()?.toLowerCase();
        if (extension && this.formatosPermitidosPlanAnual.includes(extension)) {
          this.archivoSeleccionado = file;
          this.archivoDigitalPlanAnual.file = file;
          this.estadoSubida = "";
          this.mensajeSubida = "";
          console.log('📄 Archivo seleccionado:', file.name);
          this.mostrarSwalAccion('success', 'Archivo cargado', `Se selecciono ${file.name}`);
        } else {
          Swal.fire('Error', `Solo se permiten: ${this.formatosPermitidosPlanAnualTexto || '.pdf, .doc, .docx'}`, 'error');
        }
      }
    }
  
    onDragOver(event: DragEvent): void {
      event.preventDefault();
      event.stopPropagation();
    }
  
    onDragLeave(event: DragEvent): void {
      event.preventDefault();
      event.stopPropagation();
    }
  
    onDrop(event: DragEvent): void {
      event.preventDefault();
      event.stopPropagation();
  
      const files = event.dataTransfer?.files;
      if (files && files.length > 0) {
        const file = files[0];
        const extension = file.name.split('.').pop()?.toLowerCase();
        if (extension && this.formatosPermitidosPlanAnual.includes(extension)) {
          this.archivoSeleccionado = file;
          this.archivoDigitalPlanAnual.file = file;
          this.estadoSubida = "";
          this.mensajeSubida = "";
          console.log('📄 Archivo arrastrado:', file.name);
          this.mostrarSwalAccion('success', 'Archivo cargado', `Se selecciono ${file.name}`);
        } else {
          Swal.fire('Error', `Solo se permiten: ${this.formatosPermitidosPlanAnualTexto || '.pdf, .doc, .docx'}`, 'error');
        }
      }
    }
  
    eliminarArchivo(): void {
  
  
      this.archivoSeleccionado = null;
      this.archivoDigitalPlanAnual.file = null;
      this.estadoSubida = "";
      this.mensajeSubida = "";
      this.progresoSubida = 0;
    }
  
    onFileChangeEditar(event: any): void {
      const file = event.target.files[0];
      if (file) {
        const extension = file.name.split('.').pop()?.toLowerCase();
        if (extension && this.formatosPermitidosPlanAnual.includes(extension)) {
          this.archivoSeleccionadoEditar = file;
          console.log('📄 Archivo seleccionado para editar:', file.name);
        } else {
          Swal.fire('Validación', `Solo se permiten: ${this.formatosPermitidosPlanAnualTexto || '.pdf, .doc, .docx'}`, 'warning');
          event.target.value = '';
          this.archivoSeleccionadoEditar = null;
        }
      }
    }
  
    eliminarArchivoEditar(): void {
      this.archivoSeleccionadoEditar = null;
    }
  
    subirDocumento(): void {
      if (!this.formPlanAnual.valid) {
        this.formPlanAnual.markAllAsTouched();
        Swal.fire('Validación', 'Completa la versión y las fechas del plan anual', 'warning');
        return;
      }
  
      const codigo = this.normalizarCodigoPlanAnual(this.formPlanAnual.get('codigo')?.value);
      const fechaDesignacion = String(this.formPlanAnual.get('fecha_designacion')?.value || '').trim();
      const fechaVencimiento = String(this.formPlanAnual.get('fecha_vencimiento')?.value || '').trim();
      const motivo_cambio = String(this.formPlanAnual.get('motivo_cambio')?.value || '').trim();
  
      if (!codigo || !fechaDesignacion || !fechaVencimiento) {
        Swal.fire('Error', 'Versión, fecha de designación y fecha de vencimiento son obligatorios', 'error');
        return;
      }
  
      this.estadoSubida = "subiendo";
      this.progresoSubida = 0;
      this.mensajeSubida = "";
      this.mostrarSwalAccion('info', 'Procesando', 'Guardando plan anual y documento...');
  
      const archivoSeleccionado = this.archivoSeleccionado;
      // ✅ SIEMPRE incluir el NIT administrativo en la ruta de Digitales PESV
      const nit = this.empresaNit || 'nit';
      const nombreCarpeta = `${nit}/pesv/cargados/${codigo}`;
      const nombreArchivo = archivoSeleccionado
        ? this.construirNombreArchivoDocumentoPlanAnualPorCodigo(codigo, archivoSeleccionado)
        : "";
      const prefijo = this.archivoDigitalPlanAnual.prefijo || 'PAT';
      const id = Number(this.archivoDigitalPlanAnual.id || 3);
  
      const payload = {
        codigo,
        fecha_designacion: fechaDesignacion,
        fecha_vencimiento: fechaVencimiento,
        motivo_cambio: motivo_cambio || "",
        estado: 1,
      };
  
      const editandoId = this.planEditandoId;
  
      this.planAnualService.getAll().subscribe({
        next: (planAnuales: any[]) => {
          const planAnualExistente = (Array.isArray(planAnuales) ? planAnuales : []).find(
            (planAnual: any) => this.normalizarCodigoPlanAnual(planAnual?.codigo || "") === codigo,
          );
  
          const codigoDuplicado = !!planAnualExistente && String(planAnualExistente?.id) !== String(editandoId ?? "");
  
          if (codigoDuplicado) {
            this.estadoSubida = "error";
            this.progresoSubida = 0;
            this.mensajeSubida = `La versión ${codigo} ya existe. Cambia la versión para poder guardar.`;
            this.mostrarSwalAccion('warning', 'Versión duplicada', this.mensajeSubida);
            return;
          }
  
          const guardarPlanAnual = editandoId
            ? this.planAnualService.update(editandoId, payload)
            : this.planAnualService.create(payload);
  
          guardarPlanAnual.subscribe({
            next: (planAnualGuardado: any) => {
              const formularioGuardado = !!planAnualGuardado;
              if (!formularioGuardado) {
                this.estadoSubida = "error";
                this.mensajeSubida = "No se pudo confirmar el guardado del formulario";
                this.mostrarSwalAccion('error', 'Error', this.mensajeSubida);
                return;
              }
  
              const idPlanAnual = planAnualGuardado?.id ?? editandoId ?? codigo;
  
              console.log('📤 Guardando plan anual y subiendo documento:', {
                carpeta: nombreCarpeta,
                nombre: nombreArchivo,
                codigo,
                planAnual: idPlanAnual,
                prefijo: prefijo
              });
  
              if (!archivoSeleccionado) {
                if (editandoId) {
                  this.estadoSubida = "exito";
                  this.mensajeSubida = "Plan Anual actualizado correctamente";
                  this.mostrarSwalAccion('success', 'Exito', this.mensajeSubida);
                  this.planEditandoId = null;
                  this.formPlanAnual.reset();
                  this.eliminarArchivo();
                  this.cargarHistorialPlanAnual();
                  return;
                }
  
                const nombreArchivoDefault = `PAT_documental_${codigo}.pdf`;
                this.formatosService.generarDocumentoPdf(this.formatoPlanAnualId, {
                  version: this.formPlanAnual.get("codigo")?.value || this.planCodigoOriginal || "",
                  fecha: this.formPlanAnual.get("fecha_designacion")?.value || "",
                  fechaPublicacion: this.formPlanAnual.get("fecha_designacion")?.value || "",
                }).subscribe({
                  next: (blobDefault: Blob) => {
                    // Solo se genera y sube el documento despues de guardar el formulario.
                    const archivoDefault = new File(
                      [blobDefault],
                      nombreArchivoDefault,
                      {
                        type: "application/pdf",
                      },
                    );
  
                    this.subirArchivoPlanAnual(
                      archivoDefault,
                      id,
                      nombreCarpeta,
                      nombreArchivoDefault,
                      prefijo,
                      "Plan Anual guardado",
                    );
                  },
                  error: (err: any) => {
                    this.estadoSubida = "error";
                    this.mensajeSubida = "El plan anual se guardó, pero falló la generación del documento ";
                    console.error('❌ Error al generar documento de plan anual:', err);
                    this.mostrarSwalAccion('warning', 'Plan Anual guardado con observacion', this.mensajeSubida);
                    setTimeout(() => {
                      this.cargarHistorialPlanAnual();
                    }, 1200);
                  },
                });
                return;
              }
  
              this.subirArchivoPlanAnual(
                archivoSeleccionado,
                id,
                nombreCarpeta,
                nombreArchivo,
                prefijo,
                editandoId ? "Plan Anual actualizado y documento subido correctamente" : "Plan Anual guardado y documento subido correctamente",
              );
            },
            error: (err: any) => {
              this.estadoSubida = "error";
              this.mensajeSubida = this.obtenerMensajeError(err, 'Error al guardar el plan anual');
              console.error('❌ Error al guardar plan anual:', err);
              this.mostrarSwalAccion('error', 'Error', this.mensajeSubida);
            }
          });
        },
        error: (err: any) => {
          this.estadoSubida = "error";
          this.mensajeSubida = this.obtenerMensajeError(err, "No se pudo validar el plan anual antes de guardar");
          console.error('❌ Error consultando planes anuales antes de guardar:', err);
          this.mostrarSwalAccion('error', 'Error', this.mensajeSubida);
        },
      });
    }
  
    private subirArchivoPlanAnual(
      archivo: File,
      idDigital: number,
      carpeta: string,
      nombreArchivo: string,
      prefijo: string,
      mensajeExito: string,
    ): void {
      this.digitalesService.subirArchivo(
        archivo,
        idDigital,
        carpeta,
        nombreArchivo,
        prefijo
      ).subscribe({
        next: (event: any) => {
          if (event.type === HttpEventType.UploadProgress) {
            this.progresoSubida = Math.round((100 * event.loaded) / event.total);
            console.log(`📊 Progreso: ${this.progresoSubida}%`);
          } else if (event.type === HttpEventType.Response) {
            this.estadoSubida = "exito";
            this.mensajeSubida = mensajeExito;
            console.log('✅ Documento subido:', event.body);
            this.mostrarSwalAccion('success', 'Exito', mensajeExito);
            this.planEditandoId = null;
  
            setTimeout(() => {
              this.formPlanAnual.reset();
              this.eliminarArchivo();
              this.cargarHistorialPlanAnual();
            }, 2000);
          }
        },
        error: (err: any) => {
          this.estadoSubida = "error";
          this.mensajeSubida = this.obtenerMensajeError(err, 'Error al subir el documento');
          console.error('❌ Error al subir:', err);
          this.mostrarSwalAccion('error', 'Error', this.mensajeSubida);
        }
      });
    }
  
    // ===========================
    // Métodos para documentos GCP
    // ===========================
    visualizarDocumentoGCP(nombreArchivo: string): void {
      if (!nombreArchivo) {
        Swal.fire('Error', 'No se especificó el nombre del archivo', 'error');
        return;
      }
  
      this.cargando = true;
      console.log('👁️ Descargando documento de GCP para visualizar:', nombreArchivo);
  
      const descargarDesdeDigitales = () => {
        this.digitalesService.descargarDocumento3(this.obtenerCarpetaDigitalPlanAnual(), nombreArchivo).subscribe({
          next: (blob: Blob) => {
            this.cargando = false;
            const url = URL.createObjectURL(blob);
            this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
            this.tabActivo = 1;
            console.log('✅ Documento cargado desde digitales para visualización');
          },
          error: (err: any) => {
            this.cargando = false;
            Swal.fire('Error', this.obtenerMensajeError(err, 'No se pudo cargar el documento desde GCP'), 'error');
            console.error('❌ Error al visualizar documento GCP:', err);
          }
        });
      };
  
      if (!this.empresaNit) {
        descargarDesdeDigitales();
        return;
      }
  
      this.digitalesService.descargarDocumentoPesvCargado(this.empresaNit, this.obtenerCarpetaCargadosPlanAnual(), nombreArchivo).subscribe({
        next: (blob: Blob) => {
          this.cargando = false;
          const url = URL.createObjectURL(blob);
          this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
          this.tabActivo = 1;
          console.log('✅ Documento cargado desde cargados para visualización');
        },
        error: () => {
          descargarDesdeDigitales();
        }
      });
    }
  
   
  
      previsualizarVersion(id: any): void {
      this.versionPreview = true;
      console.log(id);
      this.descargarVersion(id, () => {
        this.versionPreview = false;
      });
    }
  
    //Descargar//
  
    descargarVersion(
      id: any,
      onFinish?: () => void,
      tipoSalida?: "pdf" | "word",
    ): void {
      // ✅ Validar que tenemos al menos documento y un identificador de versión
      const tieneIdentificadorVersion = !!(
        id?.numero_version ||
        id?.id ||
        id?.version_id
      );
      if (!this.documento_id || !tieneIdentificadorVersion) {
        Swal.fire({
          icon: "warning",
          title: "Información incompleta",
          text: "No se puede descargar. Faltan datos requeridos del documento o la versión.",
          confirmButtonText: "Aceptar",
        });
        if (!this.versionData.numero_version && !id?.id && !id?.version_id) {
        }
  
        return;
      }
  
      const nombreDocumentoId = this.obtenerNombreDocumentoId({
        nombre_id: this.formData?.nombre,
        nombre: this.formData?.nombre,
      });
      const esPlanAnualPesv = nombreDocumentoId === 4;
  
      const versionId = id?.id || id?.version_id;
  
      if (!versionId) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "No se encontró el ID de la versión.",
          confirmButtonText: "Aceptar",
        });
        return;
      }
  
      this.iniciarDescargaCancelable(
        "Descargando...",
        "Por favor espera mientras se descarga el documento.",
      );
  
      this.descargaActivaSub = this.digitalesService
        .descargarArchivoPorVersionId(versionId, tipoSalida)
        .subscribe({
          next: (response: any) => {
            if (this.descargaCancelada) {
              return;
            }
  
            this.cerrarDescargaCancelable();
  
            const blob: Blob = response?.body || response;
  
            const contentDisposition =
              response?.headers?.get("content-disposition") || "";
  
            const nombreHeaderMatch =
              /filename\*=UTF-8''([^;]+)|filename=\"?([^\";]+)\"?/i.exec(
                contentDisposition,
              );
  
            let nombreArchivo = decodeURIComponent(
              (nombreHeaderMatch?.[1] || nombreHeaderMatch?.[2] || "")
                .replace(/\"/g, "")
                .trim(),
            );
  
            if (!nombreArchivo) {
              nombreArchivo = `DOCUMENTO_VERSION_${versionId}`;
            }
  
            if (this.versionPreview) {
              this.abrirBlob(nombreArchivo, blob);
              onFinish?.();
            } else {
              const url = window.URL.createObjectURL(blob);
  
              const a = document.createElement("a");
              a.href = url;
              a.download = nombreArchivo;
  
              document.body.appendChild(a);
              a.click();
  
              document.body.removeChild(a);
              window.URL.revokeObjectURL(url);
  
              onFinish?.();
            }
          },
          error: (error) => {
            console.error("❌ Error descargando versión:", error);
  
            this.cerrarDescargaCancelable();
  
            Swal.fire({
              icon: "error",
              title: "Error al descargar",
              text: "No se pudo descargar el documento.",
              confirmButtonText: "Aceptar",
            });
          },
        });
  
      return;
    }
  
      private normalizarSegmentoRuta(valor: string): string {
      return (valor || "")
        .toString()
        .replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚñÑüÜ_-]/g, "-")
        .replace(/-+/g, "-")
        .replace(/^-|-$/g, "");
    }
  
      private obtenerNombreDocumentoId(payload: any): number | null {
        const valor = payload?.nombre_id ?? payload?.nombre?.id ?? payload?.nombre;
        if (valor === null || valor === undefined || valor === "") return null;
        const id = typeof valor === "string" ? parseInt(valor, 10) : Number(valor);
        return Number.isNaN(id) ? null : id;
      }
  
      private construirPayloadVersionSeleccionada(version: any, contexto: any): any {
        return {
          versionId: version?.id ?? version?.version_id ?? null,
          numero_version: version?.numero_version ?? version?.version ?? null,
          ...contexto,
        };
      }
  
      private obtenerExtensionDesdeUrl(url: string): string {
        try {
          const ruta = new URL(url);
          const archivo = ruta.pathname.split("/").pop() || "";
          const extension = archivo.includes(".") ? (archivo.split(".").pop() || "").toLowerCase() : "";
          return extension || "bin";
        } catch {
          const archivo = (url || "").split("/").pop() || "";
          const extension = archivo.includes(".") ? (archivo.split(".").pop() || "").toLowerCase() : "";
          return extension || "bin";
        }
      }
  
      private iniciarDescargaCancelable(titulo: string, texto: string): void {
        this.descargaCancelada = false;
        this.descargaActivaSub?.unsubscribe();
        this.descargaActivaSub = null;
  
        Swal.fire({
          title: titulo,
          text: texto,
          allowOutsideClick: false,
          allowEscapeKey: false,
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          didOpen: () => {
            Swal.showLoading();
          },
        }).then((result: any) => {
          if (result.dismiss === Swal.DismissReason.cancel) {
            this.descargaCancelada = true;
            this.descargaActivaSub?.unsubscribe();
            this.descargaActivaSub = null;
          }
        });
      }
  
      private cerrarDescargaCancelable(): void {
        this.descargaActivaSub = null;
        if (Swal.isVisible()) {
          Swal.close();
        }
      }
  
      private abrirBlob(nombreArchivo: string, blob: Blob): void {
        if (this.descargaCancelada) {
          return;
        }
  
        this.cerrarDescargaCancelable();
  
        const objectUrl = window.URL.createObjectURL(blob);
        // Si es PDF preferimos abrir en nueva pestaña para mejor experiencia
        const tipo = (blob && blob.type) ? String(blob.type).toLowerCase() : "";
        if (tipo.includes("pdf")) {
          window.open(objectUrl, "_blank");
          // dejamos que el navegador maneje la pestaña; liberamos URL más tarde
          setTimeout(() => {
            try { window.URL.revokeObjectURL(objectUrl); } catch (e) { /* ignore */ }
          }, 2000);
          return;
        }
  
        const a = document.createElement("a");
        a.href = objectUrl;
        a.download = nombreArchivo;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(objectUrl);
      }
  
        abrirmodalCrear(): void {
      if (this.tienePlanAnualVigente) {
        Swal.fire({
          icon: 'warning',
          title: 'No se puede crear un nuevo plan anual',
          text: 'Ya existe un plan anual de seguridad vial vigente. Inactive el actual o espere a que venza para crear uno nuevo.'
        });
        return;
      }
  
      this.modalCrearPlanAnualRef = this.modalService.open(
        this.modalCrearPlanAnual,
        {
          centered: true,
          size: 'lg'
        }
      );
  
      this.modalCrearPlanAnualRef.result.finally(() => {
        // Limpiar formulario si es necesario
        // this.formCrearPlanAnual.reset();
      });
    }
      
    
      /**
       * Manejar selección de archivo PDF
       */
      onPdfFileSelected(event: any): void {
        const file = event?.target?.files?.[0];
        if (!file) {
          return;
        }
    
        this.asignarPdfActaSeleccionado(file);
        event.target.value = "";
      }
    
      onDragOverPdf(event: DragEvent): void {
        event.preventDefault();
        const target = event.currentTarget as HTMLElement;
        target.classList.add("drag-over");
      }
    
      onDragLeavePdf(event: DragEvent): void {
        event.preventDefault();
        const target = event.currentTarget as HTMLElement;
        target.classList.remove("drag-over");
      }
    
      onDropPdfActa(event: DragEvent): void {
        event.preventDefault();
        const target = event.currentTarget as HTMLElement;
        target.classList.remove("drag-over");
    
        const file = event.dataTransfer?.files?.[0];
        if (!file) {
          return;
        }
    
        this.asignarPdfActaSeleccionado(file);
        event.dataTransfer?.clearData();
      }
    
    removePdfActaSeleccionado(): void {
  
      this.pdfFileSelected = null;
  
      this.formPlanAnual.patchValue({
        soporte: null
      });
  
      this.formPlanAnual.get('soporte')?.updateValueAndValidity();
    }
    private asignarPdfActaSeleccionado(file: File): void {
  
    const extension = file.name.split('.').pop()?.toLowerCase() || '';
  
    if (extension !== 'pdf') {
      Swal.fire("Error", "Solo se permiten archivos PDF", "error");
      return;
    }
  
    const maxSize = 10 * 1024 * 1024;
  
    if (file.size > maxSize) {
      Swal.fire("Error", "El archivo no debe superar los 10MB", "error");
      return;
    }
  
    this.pdfFileSelected = file;
  
    // 👇 IMPORTANTE: actualizar el FormGroup
    this.formPlanAnual.patchValue({
      soporte: file
    });
  
    this.formPlanAnual.get('soporte')?.updateValueAndValidity();
  
    console.log('Soporte agregado:', this.formPlanAnual.value);
  }
  
        formatFileSize(bytes: number): string {
      if (bytes === 0) return "0 Bytes";
      const k = 1024;
      const sizes = ["Bytes", "KB", "MB", "GB"];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + " " + sizes[i];
    }
  
    calcularVencimiento(): void {
  
    const fechaDesignacion = this.formPlanAnual.get('fecha_designacion')?.value;
  
    if (!fechaDesignacion) {
      return;
    }
  
    const fecha = new Date(fechaDesignacion);
  
    fecha.setFullYear(fecha.getFullYear() + 3);
  
    const fechaVencimiento = fecha.toISOString().split('T')[0];
  
    this.formPlanAnual.patchValue({
      fecha_vencimiento: fechaVencimiento
    });
  
  
   
  
    }
  
guardarPlanAnual(): void {
  if (this.tienePlanAnualVigente) {
    Swal.fire({
      icon: 'warning',
      title: 'No se puede guardar',
      text: 'Ya existe un plan anual de seguridad vial vigente. Inactive el actual o espere a que venza para crear uno nuevo.'
    });
    return;
  }

  if (this.formPlanAnual.invalid) {
    this.formPlanAnual.markAllAsTouched();

    Swal.fire({
      icon: 'warning',
      title: 'Campos requeridos',
      text: 'Debe completar toda la información.'
    });

    return;
  }

  const planAnual = {
    codigo: this.formPlanAnual.value.codigo,
    version: this.formPlanAnual.value.version,
    fecha_designacion: this.formPlanAnual.value.fecha_designacion,
    fecha_vencimiento: this.formPlanAnual.value.fecha_vencimiento,
    estado: this.formPlanAnual.value.estado,
    motivo_creacion: this.formPlanAnual.value.motivo_creacion,
    soporte: this.formPlanAnual.value.soporte
  };

  // ✅ Separamos el archivo para no mandarlo dentro del JSON al crear el registro
  const { soporte, ...planAnualPayload } = planAnual;

  console.log('📤 Payload que se envía a create():', planAnualPayload);

  Swal.fire({
    title: 'Guardando plan anual PESV...',
    text: 'Espere un momento',
    allowOutsideClick: false,
    didOpen: () => {
      Swal.showLoading();
    }
  });

  this.planAnualService.create(planAnualPayload)
    .subscribe({

      next: (resp: any) => {
        console.log('✅ Respuesta completa del backend:', resp);
        Swal.close();

        // ✅ Determinamos éxito de forma robusta:
        // - Si el backend devuelve un objeto con id -> se creó correctamente.
        // - Si el backend usa un flag explícito (success/ok) lo respetamos también.
        // - Evitamos usar resp.codigo porque colisiona con el campo "codigo" del plan.
        const idCreado = resp?.id ?? resp?.data?.id ?? resp?.planAnual?.id ?? null;
        const exitoExplicito = resp?.success === true || resp?.ok === true;
        const ok = !!idCreado || exitoExplicito;

        if (!ok) {
          console.warn('⚠️ No se pudo determinar éxito en la respuesta. resp:', resp);
          Swal.fire({
            icon: 'warning',
            title: 'Atención',
            text: resp?.message || 'Respuesta no exitosa'
          });
          return;
        }

        if (planAnual.soporte) {
          this.subirArchivoPlanAnual(
            planAnual.soporte,
            idCreado,
            `${this.empresaNit}/pesv/documental/plan-anual/${planAnual.codigo}`,`${planAnual.codigo}_PESV.pdf`,
            'PAT',
            'Plan anual y documento subidos correctamente'
          );
        } else {
          Swal.fire({
            icon: 'success',
            title: 'Éxito',
            text: resp?.message || 'Plan anual guardado correctamente'
          });
        }

        // Reset del formulario
        this.formPlanAnual.reset({
          version: '1.0',
          estado: 1,
          motivo_creacion: ''
        });

        this.pdfFileSelected = null;

        // ✅ cerrar modal
        this.modalCrearPlanAnualRef?.close();

        // ✅ recargar lista
        this.cargarHistorialPlanAnual();
      },

      error: (error) => {
        console.error('❌ Error backend:', error);

        const mensaje =
          error?.error?.error ||
          error?.error?.message ||
          'Error inesperado';

        Swal.fire({
          icon: 'error',
          title: 'No se pudo guardar',
          text: mensaje
        });
      }

    });
}
  
  getEstadoDocumento(): void {
  
    this.estadoDocumentosService.getAllEstados()
      .subscribe({
  
        next: (resp: any) => {
  
        //  console.log('Estados:', resp);
          this.estadosPlanAnual = resp;
          
        },
  
        error: (error) => {
  
          console.error(error);
  
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'No fue posible cargar los estados del documento.'
          });
  
        }
  
      });
  
  }
  
visualizarPDF(planAnual: any): void {
  if (!planAnual.codigo) {
    Swal.fire("Error", "No se puede visualizar sin ID", "error");
    return;
  }
  Swal.fire({
    title: "Confirmar visualización",
    text: "¿Deseas visualizar el documento: Plan Anual PESV?",
    icon: "question",
    showCancelButton: true,
    confirmButtonText: "Visualizar",
    cancelButtonText: "Cancelar",
  }).then((result) => {
    if (!result.isConfirmed) {
      return;
    }

    if (!this.empresaNit) {
      Swal.close();
      Swal.fire(
        "Error",
        "No se pudo obtener el NIT de la empresa para visualizar el documento.",
        "error",
      );
      return;
    }

    console.log("Visualizando plan anual:", planAnual); 
    // ✅ mismo nombre de archivo que se usó al guardar en subirArchivoPlanAnual
    //const nombreArchivo = `${planAnual.codigo}.pdf`;
    const nombreArchivo = `PAT_documental.pdf`;
    const rutaPlanAnual = `${this.empresaNit}/pesv/documental/plan-anual/${planAnual.codigo}/${planAnual.id}/${nombreArchivo}`;

    this.gpcGoogle.getSignedUrlFiles(rutaPlanAnual).subscribe({
      next: (resp) => {
        Swal.close();
        if (!resp?.url) {
          Swal.fire(
            "Error",
            "No se pudo obtener la URL del documento del plan anual PESV.",
            "error",
          );
          return;
        }

        this.googleStoragePreview.open(resp.url, "Plan Anual PESV");
      },
      error: (err) => {
        Swal.close();
        console.error(
          "❌ Error al obtener la URL del documento del plan anual PESV.",
          err,
        );
        Swal.fire(
          "Error",
          "No se pudo obtener la URL del documento del plan anual PESV.",
          "error",
        );
      },
    });
  });
}

descargarDocumentoPlanAnual(planAnual: any): void {
  if (!planAnual.codigo) {
    Swal.fire("Error", "No se puede descargar sin ID", "error");
    return;
  }

  const id = Number(planAnual.id);
  if (Number.isNaN(id)) {
    Swal.fire("Error", "ID de plan anual inválido.", "error");
    return;
  }

  Swal.fire({
    title: "Descargando...",
    text: "Por favor espera mientras se descarga el documento.",
    allowOutsideClick: false,
    allowEscapeKey: false,
    showConfirmButton: false,
    didOpen: () => {
      Swal.showLoading();
    },
  });

  const fileName = `PAT_documental.pdf`; // nombre con el que se descarga al usuario, puede ser distinto
  const descargarConUrl = (url: string) => {
    Swal.close();
    this.descargarDesdeUrlFirmada(url, fileName);
  };

  if (!this.empresaNit) {
    Swal.close();
    Swal.fire(
      "Error",
      "No se pudo obtener el NIT de la empresa para descargar el documento.",
      "error",
    );
    return;
  }

  // ✅ mismo nombre de archivo que se usó al guardar en subirArchivoPlanAnual
  const nombreArchivoGuardado = `PAT_documental.pdf`;
  console.log("plan anual:", planAnual);
  const rutaPlanAnual = `${this.empresaNit}/pesv/documental/plan-anual/${planAnual.codigo}/${planAnual.id}/${nombreArchivoGuardado}`;

  

  this.gpcGoogle.getSignedUrlFiles(rutaPlanAnual).subscribe({
    next: (resp) => {
      if (!resp?.url) {
        Swal.fire(
          "Error",
          "No se pudo obtener la URL firmada del documento.",
          "error",
        );
        return;
      }

      descargarConUrl(resp.url);
      Swal.close();
    },
    error: (err) => {
      Swal.close();
      console.error(
        "❌ Error al obtener la URL firmada del documento del plan anual PESV.",
        err,
      );
      Swal.fire(
        "Error",
        "No se pudo obtener la URL firmada del documento.",
        "error",
      );
    },
  });
}
  
  
        private descargarDesdeUrlFirmada(url: string, fileName: string): void {
            fetch(url)
              .then((response) => {
                if (!response.ok) {
                  throw new Error(`Error al descargar archivo: ${response.status}`);
                }
                return response.blob();
              })
              .then((blob) => {
                const objectUrl = window.URL.createObjectURL(blob);
                const enlace = document.createElement("a");
                enlace.href = objectUrl;
                enlace.download = fileName;
                enlace.style.display = "none";
                document.body.appendChild(enlace);
                enlace.click();
                document.body.removeChild(enlace);
                window.URL.revokeObjectURL(objectUrl);
              })
              .catch((error) => {
                console.error("Error al descargar URL firmada:", error);
                Swal.fire("Error", "No se pudo descargar el documento.", "error");
              });
          }
  }